import angular from 'angular';

import service from './smoothScroll.service';
import directive from './smoothScroll.directive';
import Browser from 'cars-ng-browser';

export default angular.module('vdp.smoothScroll', [
    /* your module dependencies go here */
    Browser
])

.service('smoothScrollService', service)
.directive('carsSmoothScroll', directive)

.name;
